import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
  DialogActions,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { getSessionStorage } from "src/utils/storage";
import toast from "react-hot-toast";
import { API_SERVICE_BACKEND } from "src/config";
import {
  TextInput,
  NumberInput,
  SwitchInput,
  SelectInput,
} from "./InputComponents";
import axios from "axios";

const initialFormState = {
  // Credits & Limits
  CONTACT_LOOKUPS: 1000000, // unlimited
  EMAIL_SENDING: 1000000, // unlimited
  LEADS: 0,
  EMAIL_VALIDATION: 0,
  AI: 0,
  // // AI Copilot
  // AI_VOICE_AGENT_MINS: 0,
  // AI_COPILOT_TASKS: 0,
  // WEBSITE_INTEL_CREDITS: 0,
  // others
  CONTACT_EXPORTS: 1000000,
  CONTACT_IMPORTS: 1000000,
  // DATA_ENRICHMENT: 0,
  // Features
  AI_KNOWLEDGE_BASE_PAGES: 0,
  AI_AUTO_REPLIES: false,
  AI_AUTOPILOT: false,
  INTENT_DATA_TOPICS: null,
  ADVANCED_FILTERS: false,
  USER_MAILBOXES: null,
  DFY_DOMAINS: null,
  AB_TESTING: false,
  GLOBAL_BLOCKLIST: false,
  DOMAIN_TRACKING: false,
  MULTICHANNEL_ACCOUNTS: null,
  SMS_ACCOUNTS: 0,
  WHATSAPP_ACCOUNTS: 0,
  UNIFIED_INBOX: false,
  DEAL_PIPELINES: 0,
  CAMPAIGN_ANALYTICS: true,
  GLOBAL_ANALYTICS: false,
  DASHBOARD: false,
  WORKSPACES: false,
  TEAM_MEMBERS: null,
  ZAPIER: false,
  HUBSPOT: false,
  ZOHO: false,
  SALESFORCE: false,
  WEBINARS: true,
  CHAT_SUPPORT: true,
  INTEGRATIONS: false,
};

const basic = {
  // Credits & Limits
  CONTACT_LOOKUPS: 1000000, // unlimited
  EMAIL_SENDING: 1000000, // unlimited
  LEADS: 2000,
  EMAIL_VALIDATION: 2000,
  AI: 2000,
  // // AI Copilot
  // AI_VOICE_AGENT_MINS: 0,
  // AI_COPILOT_TASKS: 0,
  // WEBSITE_INTEL_CREDITS: 0,
  // others
  CONTACT_EXPORTS: 1000000,
  CONTACT_IMPORTS: 1000000,
  // DATA_ENRICHMENT: 2000,
  // Features
  LEADS_IMPORT: 100000,
  AI_KNOWLEDGE_BASE_PAGES: 1000,
  // Artificial Intelligence
  AI_AUTO_REPLIES: false,
  AI_AUTOPILOT: false,
  // Contact Database
  INTENT_DATA_TOPICS: 3,
  ADVANCED_FILTERS: false,
  // Campaigns & Sequences
  USER_MAILBOXES: 1,
  DFY_DOMAINS: null,
  AB_TESTING: true,
  GLOBAL_BLOCKLIST: true,
  DOMAIN_TRACKING: false,
  // Multichannel Outreach
  MULTICHANNEL_ACCOUNTS: 0,
  SMS_ACCOUNTS: 0,
  WHATSAPP_ACCOUNTS: 0,
  // Inbox & CRM
  UNIFIED_INBOX: true,
  DEAL_PIPELINES: 1,
  // Analytics & Reporting
  CAMPAIGN_ANALYTICS: true,
  GLOBAL_ANALYTICS: true,
  DASHBOARD: true,
  // Additional Functionality
  WORKSPACES: true,
  TEAM_MEMBERS: 1,
  // Integrations
  ZAPIER: true,
  HUBSPOT: false,
  ZOHO: false,
  SALESFORCE: false,
  //Support & Knowledge
  WEBINARS: true,
  CHAT_SUPPORT: true,
  HELP_CENTER: true,
  ONE_ON_ONE_SUPPORT: false,
};

const scale = {
  // Credits & Limits
  CONTACT_LOOKUPS: 1000000, // unlimited
  EMAIL_SENDING: 1000000, // unlimited
  LEADS: 10000,
  EMAIL_VALIDATION: 10000,
  AI: 10000,
  // // AI Copilot
  // AI_VOICE_AGENT_MINS: 60,
  // AI_COPILOT_TASKS: 10000,
  // WEBSITE_INTEL_CREDITS: 1000,
  // others
  CONTACT_EXPORTS: 1000000,
  CONTACT_IMPORTS: 1000000,
  // DATA_ENRICHMENT: 10000,
  // Features
  LEADS_IMPORT: 100000,
  AI_KNOWLEDGE_BASE_PAGES: 10000,
  // Artificial Intelligence
  AI_AUTO_REPLIES: true,
  AI_AUTOPILOT: false,
  // Contact Database
  INTENT_DATA_TOPICS: 6,
  ADVANCED_FILTERS: true,
  // Campaigns & Sequences
  USER_MAILBOXES: 5,
  DFY_DOMAINS: null,
  AB_TESTING: true,
  GLOBAL_BLOCKLIST: true,
  DOMAIN_TRACKING: true,
  // Multichannel Outreach
  MULTICHANNEL_ACCOUNTS: 1,
  SMS_ACCOUNTS: 1,
  WHATSAPP_ACCOUNTS: 0,
  // Inbox & CRM
  UNIFIED_INBOX: true,
  DEAL_PIPELINES: 1,
  // Analytics & Reporting
  CAMPAIGN_ANALYTICS: true,
  GLOBAL_ANALYTICS: true,
  DASHBOARD: true,
  // Additional Functionality
  WORKSPACES: true,
  TEAM_MEMBERS: 3,
  // Integrations
  ZAPIER: true,
  HUBSPOT: true,
  ZOHO: true,
  SALESFORCE: false,
  //Support & Knowledge
  WEBINARS: true,
  CHAT_SUPPORT: true,
  HELP_CENTER: true,
  ONE_ON_ONE_SUPPORT: false,
};

const unlimited = {
  // Credits & Limits
  CONTACT_LOOKUPS: 1000000, // unlimited
  EMAIL_SENDING: 1000000, // unlimited
  LEADS: 25000,
  EMAIL_VALIDATION: 25000,
  AI: 25000,
  // // AI Copilot
  // AI_VOICE_AGENT_MINS: 180,
  // AI_COPILOT_TASKS: 20000,
  // WEBSITE_INTEL_CREDITS: 5000,
  // others
  CONTACT_EXPORTS: 1000000,
  CONTACT_IMPORTS: 1000000,
  // DATA_ENRICHMENT: 25000,
  // Features
  LEADS_IMPORT: 100000,
  AI_KNOWLEDGE_BASE_PAGES: 50000,
  // Artificial Intelligence
  AI_AUTO_REPLIES: true,
  AI_AUTOPILOT: true,
  // Contact Database
  INTENT_DATA_TOPICS: 12,
  ADVANCED_FILTERS: true,
  // Campaigns & Sequences
  USER_MAILBOXES: 20,
  DFY_DOMAINS: null,
  AB_TESTING: true,
  GLOBAL_BLOCKLIST: true,
  DOMAIN_TRACKING: true,
  // Multichannel Outreach
  MULTICHANNEL_ACCOUNTS: 5,
  SMS_ACCOUNTS: 1,
  WHATSAPP_ACCOUNTS: 1,
  // Inbox & CRM
  UNIFIED_INBOX: true,
  DEAL_PIPELINES: 1,
  // Analytics & Reporting
  CAMPAIGN_ANALYTICS: true,
  GLOBAL_ANALYTICS: true,
  DASHBOARD: true,
  // Additional Functionality
  WORKSPACES: true,
  TEAM_MEMBERS: 5,
  // Integrations
  ZAPIER: true,
  HUBSPOT: true,
  ZOHO: true,
  SALESFORCE: true,
  //Support & Knowledge
  WEBINARS: true,
  CHAT_SUPPORT: true,
  HELP_CENTER: true,
  ONE_ON_ONE_SUPPORT: true,
};

const options = [
  {
    title: "Basic",
    value: "basic",
  },
  {
    title: "Scale",
    value: "scale",
  },
  {
    title: "Unlimited",
    value: "unlimited",
  },
];

const AddPlans = ({ setOpen, open, getAllWhiteLabelClients }) => {
  const email = getSessionStorage("userEmail");
  const [planName, setPlanName] = useState("");
  const [formState, setFormState] = useState(initialFormState);
  const [selectedTemplate, setSelectedTemplate] = useState("");
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open.data) {
      setPlanName(open.data.planName || "");
      setFormState({
        ...initialFormState,
        ...open.data.monthlyCredits,
        ...open.data.features,
      });
    }
  }, [open.data]);

  useEffect(() => {
    if (selectedTemplate === "basic") setFormState(basic);
    else if (selectedTemplate === "scale") setFormState(scale);
    else if (selectedTemplate === "unlimited") setFormState(unlimited);
    else setFormState(initialFormState);
  }, [selectedTemplate]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormState((prev) => {
      let updated = {
        ...prev,
        [name]:
          type === "checkbox" ? checked : Math.max(0, parseInt(value, 10) || 0),
      };

      // If toggling the master INTEGRATIONS switch, sync all four
      if (name === "INTEGRATIONS") {
        ["ZAPIER", "HUBSPOT", "ZOHO", "SALESFORCE"].forEach((svc) => {
          updated[svc] = checked;
        });
      }

      return updated;
    });
  };

  const handlePlanNameChange = (e) => {
    setPlanName(e.target.value);
  };

  const handlePrimaryAction = () => {
    if (!planName.trim()) {
      toast.error("Plan Name is required");
      return;
    }

    if (open.data) {
      if (open.data.userCount > 0) {
        setConfirmOpen(true);
      } else {
        submitPlan();
      }
    } else {
      submitPlan();
    }
  };

  const submitPlan = async () => {
    setLoading(true);
    const requestData = {
      userEmail: email,
      planName: planName.trim(),
      monthlyCredits: {
        CONTACT_LOOKUPS: formState.CONTACT_LOOKUPS,
        EMAIL_SENDING: formState.EMAIL_SENDING,
        AI: formState.AI,
        LEADS: formState.LEADS,
        EMAIL_VALIDATION: formState.EMAIL_VALIDATION,
        // // AI Copilot
        // AI_VOICE_AGENT_MINS: 0,
        // AI_COPILOT_TASKS: 0,
        // WEBSITE_INTEL_CREDITS: 0,
        // others
        CONTACT_EXPORTS: formState.CONTACT_EXPORTS,
        CONTACT_IMPORTS: formState.CONTACT_IMPORTS,
        // DATA_ENRICHMENT: formState.DATA_ENRICHMENT,
      },
      features: {
        LEADS_IMPORT: formState.LEADS_IMPORT,
        AI_KNOWLEDGE_BASE_PAGES: formState.AI_KNOWLEDGE_BASE_PAGES,
        AI_AUTO_REPLIES: formState.AI_AUTO_REPLIES,
        AI_AUTOPILOT: formState.AI_AUTOPILOT,
        INTENT_DATA_TOPICS: Number(formState.INTENT_DATA_TOPICS),
        ADVANCED_FILTERS: formState.ADVANCED_FILTERS,
        USER_MAILBOXES: Number(formState.USER_MAILBOXES),
        DFY_DOMAINS: Number(formState.DFY_DOMAINS),
        AB_TESTING: formState.AB_TESTING,
        GLOBAL_BLOCKLIST: formState.GLOBAL_BLOCKLIST,
        DOMAIN_TRACKING: formState.DOMAIN_TRACKING,
        MULTICHANNEL_ACCOUNTS: Number(formState.MULTICHANNEL_ACCOUNTS),
        SMS_ACCOUNTS: formState.SMS_ACCOUNTS,
        WHATSAPP_ACCOUNTS: formState.WHATSAPP_ACCOUNTS,
        UNIFIED_INBOX: formState.UNIFIED_INBOX,
        DEAL_PIPELINES: formState.DEAL_PIPELINES,
        CAMPAIGN_ANALYTICS: formState.CAMPAIGN_ANALYTICS,
        GLOBAL_ANALYTICS: formState.GLOBAL_ANALYTICS,
        DASHBOARD: formState.DASHBOARD,
        WORKSPACES: formState.WORKSPACES,
        TEAM_MEMBERS: Number(formState.TEAM_MEMBERS),
        ZAPIER: formState.ZAPIER,
        HUBSPOT: formState.HUBSPOT,
        ZOHO: formState.ZOHO,
        SALESFORCE: formState.SALESFORCE,
        WEBINARS: formState.WEBINARS,
        CHAT_SUPPORT: formState.CHAT_SUPPORT,
      },
    };

    const url = open.data
      ? `${API_SERVICE_BACKEND}/plans/${open.data._id}`
      : `${API_SERVICE_BACKEND}/plans`;
    const method = open.data ? "PUT" : "POST";

    try {
      // const response = await fetch1(url, {
      //   method,
      //   headers: { "Content-Type": "application/json" },
      //   body: JSON.stringify(requestData),
      // });
      const response = await axios({
        method,
        url,
        headers: { "Content-Type": "application/json" },
        data: requestData,
      });
      const data = response.data;

      if (response.status >= 200 && response.status < 300) {
        getAllWhiteLabelClients();
        toast.success(
          data.message ||
            (open.data
              ? "Plan updated successfully"
              : "New plan added successfully")
        );
        closeAll();
      } else {
        toast.error(data.error || "Failed to connect");
      }
    } catch (err) {
      toast.error("Error submitting data");
    } finally {
      setLoading(false);
    }
  };

  const closeAll = () => {
    setConfirmOpen(false);
    setOpen({ open: false, data: null });
    setPlanName("");
    setSelectedTemplate("");
    setFormState(initialFormState);
  };

  return (
    <>
      <Dialog open={open.open} onClose={closeAll} fullWidth maxWidth="sm">
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6">
            {open.data ? "Edit" : "Create"} a custom plan
          </Typography>
          <IconButton onClick={closeAll}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextInput
                label="Plan Name"
                name="planName"
                value={planName}
                onChange={handlePlanNameChange}
              />
            </Grid>
            <Grid item xs={12}>
              <SelectInput
                label="Start with a template"
                options={options}
                value={selectedTemplate}
                onChange={(e) => setSelectedTemplate(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h6" sx={{ pt: 2 }}>
                Credits
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <NumberInput
                label="AI"
                name="AI"
                value={formState.AI}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={4}>
              <NumberInput
                label="Leads"
                name="LEADS"
                value={formState.LEADS}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={4}>
              <NumberInput
                label="Email Validation"
                name="EMAIL_VALIDATION"
                value={formState.EMAIL_VALIDATION}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={4}>
              <NumberInput
                label="Leads Import"
                name="LEADS_IMPORT"
                value={formState.LEADS_IMPORT}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={4}>
              <NumberInput
                label="AI Knowledge Base Pages"
                name="AI_KNOWLEDGE_BASE_PAGES"
                value={formState.AI_KNOWLEDGE_BASE_PAGES}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={4}>
              <NumberInput
                label="LinkedIn Accounts"
                name="MULTICHANNEL_ACCOUNTS"
                value={formState.MULTICHANNEL_ACCOUNTS}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={4}>
              <NumberInput
                label="Team Members"
                name="TEAM_MEMBERS"
                value={formState.TEAM_MEMBERS}
                onChange={handleChange}
                max={10}
              />
            </Grid>

            <Grid item xs={4}>
              <NumberInput
                label="DFY Domains"
                name="DFY_DOMAINS"
                value={formState.DFY_DOMAINS}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={4}>
              <NumberInput
                label="User Brought Mailboxes"
                name="USER_MAILBOXES"
                value={formState.USER_MAILBOXES}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={4}>
              <NumberInput
                label="Intent Topics"
                name="INTENT_DATA_TOPICS"
                value={formState.INTENT_DATA_TOPICS}
                onChange={handleChange}
                max={12}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography
                variant="h6"
                sx={{ pt: 2, color: (theme) => theme.palette.text.primary }}
              >
                Features
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <SwitchInput
                label="Unibox"
                name="UNIFIED_INBOX"
                checked={formState.UNIFIED_INBOX}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={4}>
              <SwitchInput
                label="Deal Pipeline"
                name="DEAL_PIPELINES"
                checked={formState.DEAL_PIPELINES === 1 ? true : false}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={4}>
              <SwitchInput
                label="Integrations"
                name="INTEGRATIONS"
                checked={
                  formState.ZAPIER &&
                  formState.HUBSPOT &&
                  formState.ZOHO &&
                  formState.SALESFORCE
                }
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={4}>
              <SwitchInput
                label="Advanced Filters"
                name="ADVANCED_FILTERS"
                checked={formState.ADVANCED_FILTERS}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={4}>
              <SwitchInput
                label="AI Auto Replies"
                name="AI_AUTO_REPLIES"
                checked={formState.AI_AUTO_REPLIES}
                onChange={handleChange}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={closeAll} variant="outlined" fullWidth className="glass-button-secondary-50">
            Discard
          </Button>
          <Button
            onClick={handlePrimaryAction}
            variant="contained"
            fullWidth
            disabled={loading}
          >
            {open.data ? "Update" : "Create"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Confirmation Dialog (only when updating) */}
      <Dialog
        open={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle>Confirm Update</DialogTitle>
        <DialogContent>
          <Typography>
            This plan is assigned to {open.data?.userCount || 0} user
            {open.data?.userCount > 1 ? "s" : ""}. Updating it will immediately
            change their subscriptions. Are you sure you want to proceed?
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            onClick={() => setConfirmOpen(false)}
            variant="outlined"
            fullWidth
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              setConfirmOpen(false);
              submitPlan();
            }}
            variant="contained"
            fullWidth
          >
            Proceed
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AddPlans;
